module.exports = __webpack_public_path__ + "img/eagleEye2_4.65329d5a.png";